<template>
  <router-view/>
</template>

<style>

body {
  overflow-x: hidden;

}


* {
  -webkit-overflow-scrolling: touch
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>

<script lang="ts">

import Home from "@/views/Home.vue";
import {Component, Vue} from "vue-facing-decorator";

@Component({
  components: {
    Home
  }
})
export default class App extends Vue {

}

</script>
